import { render, staticRenderFns } from "./BackCleaner.vue?vue&type=template&id=60410c9d&scoped=true"
import script from "./BackCleaner.vue?vue&type=script&lang=js"
export * from "./BackCleaner.vue?vue&type=script&lang=js"
import style0 from "./BackCleaner.vue?vue&type=style&index=0&id=60410c9d&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60410c9d",
  null
  
)

export default component.exports